/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */

import AvailableTabs from "./AvailableTabs";
import DivContainerBody from "../../../../components/DivContainerBody";
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {CleanIcon, IconCardRelay, IconCardSettings} from "../../../../components/buttons/IconButtons";
import {AUTHENTICATION_MODEL, STEPS_CREATE_DEVICE} from "../Model/Model";
import React from "react";
import {UserRestrictionItem} from "../../Restrictions/Subcomponents/UserRestrictionItem";
import CustomCard from "../../../../components/CustomCard";

/**
 * Section component used to configure
 * 2FA device access settings.
 *
 * This component handles:
 * - Relay configuration.
 * - Authentication access configuration.
 * - Employee assignment.
 * - Department assignment.
 * - 2FA restriction configuration.
 * - Step cleanup actions.
 *
 * @component SectionCreateDevice2FA
 *
 * @param {Object} props - Component properties.
 * @param {Object} props.data - Device form data.
 * @param {Function} props.handleChange - Updates form field values.
 * @param {Function} props.handleClear - Clears step configuration values.
 * @param {Function} props.setDeviceCustomAccess - Updates assigned employees.
 * @param {Function} props.setDeviceDepartment - Updates assigned departments.
 * @param {Function} props.t - Translation function.
 * @param {number|string|undefined} props.id - Device identifier.
 * @param {Array<number|string>} props.selectForDeleteEmp - Selected employees for deletion.
 * @param {Function} props.setSelectForDeleteEmp - Updates selected employees for deletion.
 * @param {Array<number|string>} props.selectForDeleteDepa - Selected departments for deletion.
 * @param {Function} props.setSelectForDeleteDepa - Updates selected departments for deletion.
 *
 * @returns {JSX.Element} 2FA device configuration section.
 */
const SectionCreateDevice2FA = ({
                                    data,
                                    handleChange,
                                    handleClear,
                                    setDeviceCustomAccess,
                                    setDeviceDepartment,
                                    t,
                                    id,
                                    selectForDeleteEmp,
                                    setSelectForDeleteEmp,
                                    selectForDeleteDepa,
                                    setSelectForDeleteDepa}) => {

    return (
        <DivContainerBody>
            <div className={"row mb-3"}>
                <div className='d-flex justify-content-end col-12 mb-2'>
                    {id !== undefined ? (
                        ''
                    ) : (
                        <ButtonIcon
                            className='btn-clean-secondary-600'
                            id='btn_cud_clean_all_inputs'
                            Icon={CleanIcon}
                            title={'clear_instances'}
                            onClick={() => {
                                handleClear(STEPS_CREATE_DEVICE.DOSFA.INDEX);
                            }}
                            iconProps='btn-icon-svg-12px icon-color-general-00'
                        />
                    )}
                </div>

                <div className={"row"}>
                    <div className={"col-12 col-md-6"}>
                        <CustomCard classes={'card-border-8px'} classContent='p-0 overflow-hidden'>
                            <div className='d-flex align-items-center p-3'>
                                <div><IconCardRelay /></div>
                                <div className='ml-2'>
                                    <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('relay_configurations')}</p>
                                </div>
                            </div>
                            <div className={'border-bottom-shades-300'} />
                            <UserRestrictionItem
                                id="cb_e_enable_relay_2_fa"
                                name='enableRelay2FA'
                                title='enable_relay'
                                description='description_enable_relay'
                                checked={data?.dosFa?.enableRelay2FA}
                                onChange={(e) => { handleChange(e, "enableRelay2FA", 'dosFa')}}
                                className={'m-3'}
                            />
                        </CustomCard>
                    </div>
                    <div className={"col-12 col-md-6"}>
                        <CustomCard classes={'card-border-8px'} classContent='p-0 overflow-hidden'>
                        <div className='d-flex align-items-center p-3'>
                            <div><IconCardSettings /></div>
                            <div className='ml-2'>
                                <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('authentication_access')}</p>
                            </div>
                        </div>
                        <div className={'border-bottom-shades-300'} />
                            <UserRestrictionItem
                                id="cb_e_open_relay_for_all_2_fa"
                                name='openRelayForAll2FA'
                                title='allow_open_access'
                                description='description_allow_open_access'
                                checked={data?.dosFa?.openRelayForAll2FA}
                                onChange={(e) => { handleChange(e, "openRelayForAll2FA", 'dosFa')}}
                                className={"m-3"}
                            />
                        </CustomCard>
                    </div>
                </div>

                { !data?.dosFa?.openRelayForAll2FA &&
                    <div className={"mb-4 mt-4"}>
                        <AvailableTabs authentication={AUTHENTICATION_MODEL.TWO_FA}
                                       id={id}
                                       selectForDeleteEmp={selectForDeleteEmp}
                                       setSelectForDeleteEmp={setSelectForDeleteEmp}
                                       selectForDeleteDepa={selectForDeleteDepa}
                                       setSelectForDeleteDepa={setSelectForDeleteDepa}
                                       setDeviceCustomAccess={setDeviceCustomAccess}
                                       setDeviceDepartment={setDeviceDepartment}/>
                    </div>
                }

            </div>
        </DivContainerBody>
        )
}

export default SectionCreateDevice2FA
